import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import Form from '../../../../../commons/Form/Form';
import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { User, UserENT, UserRoles } from '../../../../../../types/models/user/user.types';
import { useCookies } from 'react-cookie';
import { useState } from 'react';
import { ProfileAccountFormSchema } from './ProfileAccountForm.types';
import { getProfileAccountSchema } from './ProfileAccountForm.schema';
import { UPDATE_USER_QUERY_KEY, updateUserQuery } from './ProfileAccountForm.query';
import { profileAccountData } from './ProfileAccountForm.data';
import { UpdateUserResponse } from '../../../../../../types/api/endpoints/auth/update.types';
import moment from 'moment';
import { setProfile } from '../../../../../../store/authentication/authenticationActions/authenticationActions';
import { useDispatch } from 'react-redux';
import { api } from '../../../../../../utils/api/api';
import ProfileAccountModal from '../ProfileAccountModal/ProfileAccountModal';

export default () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const [, setCookie, removeCookie] = useCookies(['token']);

  const currentUser = useCurrentUser() as User;

  const [isModalOpen, setModalOpen] = useState(false);

  const formProps = useForm<ProfileAccountFormSchema>({
    resolver: yupResolver(getProfileAccountSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      email: currentUser.email,
      phone: currentUser.phone,
      function: currentUser.function,
    },
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<Awaited<UpdateUserResponse>, Error, ProfileAccountFormSchema>(
    (data) => updateUserQuery(data),
    {
      mutationKey: UPDATE_USER_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: ({ user, accessToken }) => {
        api.setHeader('authorization', `Bearer ${accessToken}`);
        removeCookie('token', { path: '/' });
        setCookie('token', accessToken, {
          expires: moment().add(60, 'minutes').toDate(),
          path: '/',
        });
        setProfile(user as UserENT)(dispatch);
        setModalOpen(true);
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<ProfileAccountFormSchema>
        data={profileAccountData}
        {...{ formProps, onSubmit }}
        isCompany={currentUser.role === UserRoles.Entreprise}
        buttonLabel="Mettre à jour"
      />
      <ProfileAccountModal isOpen={isModalOpen} setOpen={setModalOpen} closeOnClickOutside />
    </>
  );
};
